import { FavoriteView, Filter, TagCategory } from '@iot-platform/models/common';
import {
  CommandType,
  CommonBulkOperationType,
  Device,
  DeviceReplacePreviewItem,
  DeviceStatusName,
  DeviceVariable,
  I4BBulkOperationApiResponse
} from '@iot-platform/models/i4b';
import { DataGuardCheckStatus } from '@iot-platform/models/data-guard';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const DevicesActions = createActionGroup({
  source: 'Devices',
  events: {
    'Load Device By Id': props<{ deviceId: string }>(),
    'Load Device By Id Success': props<{ device: Device }>(),
    'Load Device By Id Failure': props<{ error: unknown }>(),

    'Select Device': props<{ device: Device }>(),
    'Select Device Success': props<{ device: Device }>(),
    'Select Device Failure': props<{ error: unknown }>(),

    'Get One Silently': props<{ id: string }>(),
    'Get One Silently Success': props<{ device: Device }>(),
    'Get One Silently Failure': props<{ error: any }>(),

    'Update Device': props<{ device: Device }>(),
    'Update Device Success': props<{ device: Device }>(),
    'Update Device Failure': props<{ error: unknown }>(),

    'Replace Device': props<{ oldDevice: Device; newDevice: Device; oldDeviceStatus: DeviceStatusName; newDeviceStatus: DeviceStatusName }>(),
    'Replace Device Success': props<{ response: DeviceReplacePreviewItem[] }>(),
    'Replace Device Failure': props<{ error: unknown }>(),

    'Move Devices': props<{ devices: Device[] }>(),
    'Move Devices Success': props<{ devices: Device[]; failedCount: number }>(),
    'Move Devices Failure': props<{ errors: unknown }>(),

    'Update Bulk Progress': props<{ progress: number | null }>(),

    'Activate Device': props<{ device: Device }>(),
    'Activate Device Success': props<{ device: Device }>(),
    'Activate Device Failure': props<{ error: unknown }>(),

    'Reset Device': props<{ device: Device }>(),
    'Reset Device Success': props<{ device: Device }>(),
    'Reset Device Failure': props<{ error: unknown }>(),

    'Send Command': props<{ device: Device; command: { command: CommandType } }>(),
    'Send Command Success': emptyProps(),
    'Send Command Failure': props<{ error: unknown }>(),

    'Bulk Send Command': props<{ devicesIds: string[]; command: { command: CommandType } }>(),
    'Bulk Send Command Success': props<{ response: I4BBulkOperationApiResponse }>(),
    'Bulk Send Command Failure': props<{ error: unknown }>(),

    'Delete Device': props<{ device: Device }>(),
    'Delete Device Success': props<{ device: Device }>(),
    'Delete Device Failure': props<{ error: unknown }>(),

    'Load Device Tags': props<{ deviceId: string }>(),
    'Load Device Tags Success': props<{ tags: TagCategory[] }>(),
    'Load Device Tags Failure': props<{ error: unknown }>(),

    'Update Device Tags': props<{ deviceId: string; tags: TagCategory[] }>(),
    'Update Device Tags Success': props<{ tags: TagCategory[] }>(),
    'Update Device Tags Failure': props<{ error: unknown }>(),

    'Bulk Operation On Tag': props<{
      bulkOperationType: CommonBulkOperationType;
      tagLabelId: string;
      devicesIds: string[];
    }>(),
    'Bulk Add Tag - ': props<{ response: I4BBulkOperationApiResponse }>(),
    'Bulk Add Tag Failure': props<{ error: any }>(),
    'Bulk Remove Tag - ': props<{ response: I4BBulkOperationApiResponse }>(),
    'Bulk Remove Tag Failure': props<{ error: any }>(),
    'Bulk Replace Tag - ': props<{ response: I4BBulkOperationApiResponse }>(),
    'Bulk Replace Tag Failure': props<{ error: any }>(),

    'Load Device Variables': props<{ deviceId: string }>(),
    'Load Device Variables Success': props<{ deviceVariables: DeviceVariable[] }>(),
    'Load Device Variables Failure': props<{ error: unknown }>(),

    'Delete Device Variables': props<{ deviceVariables: DeviceVariable[] }>(),
    'Delete Device Variables Success': props<{ response: I4BBulkOperationApiResponse }>(),
    'Delete Device Variables Failure': props<{ error: unknown }>(),

    'Reset Device Variables Last Values': props<{ deviceVariables: DeviceVariable[] }>(),
    'Reset Device Variables Last Values Success': props<{ response: I4BBulkOperationApiResponse }>(),
    'Reset Device Variables Last Values Failure': props<{ error: unknown }>(),

    'Save Current Favorite View': props<{ currentFavoriteView: FavoriteView }>(),
    'Set Filters': props<{ filters: Filter[] }>(),

    'Load Data Guard Status': props<{ deviceId: string }>(),
    'Load Data Guard Status Success': props<{ status: DataGuardCheckStatus }>(),
    'Load Data Guard Status Failure': props<{ error: any }>()
  }
});
